import { render, staticRenderFns } from "./PageMic.vue?vue&type=template&id=57b1e803&scoped=true&"
import script from "./PageMic.vue?vue&type=script&lang=js&"
export * from "./PageMic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57b1e803",
  null
  
)

export default component.exports